import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft, IconPlus } from "@tabler/icons-react";
import { AdminPageHeader, Button, CifraCargando, Group } from "@/components/ui";

export function OrganizacionesHeader({
  total,
  activas,
  modoCrear,
  onIniciarCrear,
}: {
  /** undefined en la primera carga (sin caché) · se pinta una barra en vez de «0». */
  total: number | undefined;
  activas: number | undefined;
  modoCrear: boolean;
  onIniciarCrear: () => void;
}) {
  const navigate = useNavigate();
  return (
    <AdminPageHeader
      title="Organizaciones"
      description={<>Catálogo de las sociedades · <CifraCargando valor={total} /> total · <CifraCargando valor={activas} /> activa(s).</>}
      actions={
        <Group gap="xs">
          <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={() => void navigate({ to: "/admin" })}>
            Volver
          </Button>
          {!modoCrear ? (
            <Button leftSection={<IconPlus size={14} />} onClick={onIniciarCrear}>
              Nueva organización
            </Button>
          ) : null}
        </Group>
      }
    />
  );
}
